module.exports = fox._r("fonts/ostrich-sans-bold.svg", __webpack_public_path__ + "_/_/_/root/fonts/ostrich-sans-bold.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/ostrich-sans-bold.svg
// module id = 159
// module chunks = 4